import React from 'react'
import { Grid, Typography, Divider, CircularProgress, TextField, RadioGroup, FormControl, FormControlLabel, Radio } from '@material-ui/core'
import { Page, Header, CustomButton, SecaoGenerica, ModalConfirmacao } from 'components'
import { FileManager } from 'components/FileManager'
import Autocomplete from '@material-ui/lab/Autocomplete'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import CheckIcon from '@material-ui/icons/Check'
import { cutMaxLength } from 'utils/helpers'
import useStyles from './styles'
import { useEntregarVestigio } from './hooks/useEntregarVestigio'

const maxLength250 = (newValue) => cutMaxLength(newValue, 250)

export const EntregarVestigio = (props) => {
  const { route } = props
  const classes = useStyles()

  const {
    entregaVestigioForm,
    processandoVestigio,
    setores,
    processandoSetores,
    usuarios,
    processandoUsuarios,
    abrirEspelho,
    setAbrirEspelho,
    isFormError,
    processandoOperacao,
    setArquivosUpload,
    handleClickConfirmar,
    handleConfirmarOperacao,
    router,
    params,
  } = useEntregarVestigio()

  const isLoading = processandoVestigio || processandoSetores || processandoUsuarios

  const getSetorLabel = (option) => {
    if (!option) return ''
    const setorNome = option.nome?.toUpperCase() || ''
    const divisaoSigla = option.divisao?.sigla?.toUpperCase() || ''
    const regionalSigla = option.divisao?.regional?.nome?.toUpperCase() || ''
    const orgaoSigla = option.divisao?.regional?.orgao?.sigla?.toUpperCase() || ''
    return [setorNome, divisaoSigla, regionalSigla, orgaoSigla].filter(Boolean).join(' / ')
  }

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} pathname={router.location.pathname} router={router} />

      <div className={classes.results}>
        {isLoading ? (
          <div className={classes.carregando}>
            <CircularProgress disableShrink />
          </div>
        ) : (
          <Grid container className={classes.containerForm}>

            {/* Seção: Dados do Lacre */}
            <Grid item container spacing={2}>
              <Grid item md={3} sm={6} xs={12}>
                <TextField
                  error={entregaVestigioForm.hasError('lacre')}
                  helperText={entregaVestigioForm.hasError('lacre') ? entregaVestigioForm.formState.errors.lacre[0] : null}
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                  label="NÚMERO DO LACRE"
                  name="lacre"
                  onChange={(e) => entregaVestigioForm.handleChangeWithModification(e, maxLength250)}
                  value={entregaVestigioForm.formState.values.lacre || ''}
                />
                <Typography variant="caption" className={classes.captionText}>
                  Caracteres restantes: {250 - (entregaVestigioForm.formState.values.lacre?.length || 0)}
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography variant="body2" className={classes.embalagemTitulo}>TIPO DA EMBALAGEM</Typography>
                <FormControl component="fieldset" fullWidth>
                  <RadioGroup
                    aria-label="tipo-embalagem"
                    name="tipoEmbalagem"
                    value={entregaVestigioForm.formState.values.tipoEmbalagem || null}
                    onChange={entregaVestigioForm.handleChange}
                    className={classes.radioGroup}
                  >
                    <FormControlLabel value="SACO LACRE" control={<Radio />} label={<Typography variant="body2">SACO LACRE</Typography>} />
                    <FormControlLabel value="PLÁSTICO" control={<Radio />} label={<Typography variant="body2">PLÁSTICO</Typography>} />
                    <FormControlLabel value="ENVELOPE PAPEL" control={<Radio />} label={<Typography variant="body2">ENVELOPE DE PAPEL</Typography>} />
                    <FormControlLabel value="CAIXA" control={<Radio />} label={<Typography variant="body2">CAIXA</Typography>} />
                    <FormControlLabel value="AUSENTE" control={<Radio />} label={<Typography variant="body2">AUSENTE</Typography>} />
                    <FormControlLabel value="OUTRO" control={<Radio />} label={<Typography variant="body2">OUTRO</Typography>} />
                  </RadioGroup>
                </FormControl>
              </Grid>

              {entregaVestigioForm.formState.values.tipoEmbalagem === 'OUTRO' && (
                <Grid item xs={12}>
                  <TextField
                    label="OUTRO TIPO DE EMBALAGEM"
                    name="outroTipoEmbalagem"
                    variant="outlined"
                    value={entregaVestigioForm.formState.values.outroTipoEmbalagem || ''}
                    onChange={entregaVestigioForm.handleChange}
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
              )}

            </Grid>


            {/* Seção: Dados da Entrega */}

            <SecaoGenerica titulo="Dados da Entrega" spacing={2}>
              <Grid item xs={12}>
                <Autocomplete
                  name="setorDestino"
                  value={entregaVestigioForm.formState.values.setorDestino || null}
                  noOptionsText="Sem informações"
                  options={setores}
                  onChange={(event, newValue) => entregaVestigioForm.handleChangeNewValueByNameProperty(event, newValue, 'setorDestino')}
                  getOptionSelected={(option, value) => option.id === value?.id}
                  getOptionLabel={getSetorLabel}
                  renderOption={getSetorLabel}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="SETOR DESTINO"
                      placeholder="Selecionar..."
                      InputLabelProps={{
                        shrink: true,
                      }}
                      required
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12}>
                <Autocomplete
                  name="usuarioRecebedor"
                  value={entregaVestigioForm.formState.values.usuarioRecebedor || null}
                  noOptionsText="Sem informações"
                  options={usuarios}
                  onChange={(event, newValue) => entregaVestigioForm.handleChangeNewValueByNameProperty(event, newValue, 'usuarioRecebedor')}
                  getOptionSelected={(option, value) => option.id === value?.id}
                  getOptionLabel={(option) => `${option.nome?.toUpperCase() || ''}${option.cargo?.nome ? ` - ${option.cargo.nome.toUpperCase()}` : ''}`}
                  renderOption={(option) => `${option.nome?.toUpperCase() || ''}${option.cargo?.nome ? ` - ${option.cargo.nome.toUpperCase()}` : ''}`}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      label="RESPONSÁVEL PELO RECEBIMENTO"
                      required
                    />
                  )}
                />
              </Grid>

              {entregaVestigioForm.formState.values.usuarioRecebedor?.nome?.toUpperCase() === 'OUTRO' && (
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    label="OUTRO RESPONSÁVEL PELO RECEBIMENTO"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    name="usuarioRecebedorInput"
                    value={entregaVestigioForm.formState.values.usuarioRecebedorInput || ''}
                    onChange={entregaVestigioForm.handleChange}
                  />
                </Grid>
              )}
            </SecaoGenerica>

            <SecaoGenerica titulo="Arquivos Relacionados" spacing={2}>
              <Grid item xs={12}>
                <FileManager
                  rotaUpload="/arquivo/entregavestigio"
                  rotaLoadImagem="/arquivo/entregavestigio"
                  setArquivosPai={setArquivosUpload}
                  arquivosIniciais={entregaVestigioForm.formState.values.arquivos || []}
                  tipos={['image', 'pdf']}
                />
              </Grid>
            </SecaoGenerica>

            {/* Rodapé e Ações */}
            <Grid item xs={12}>
              <Divider />
              <div className={classes.botoesFormulario}>
                <CustomButton
                  colorType="primary"
                  variant="outlined"
                  onClick={() => router.history.push(`/casos/caso/vestigio/detalhar/${params.id}`)}
                  startIcon={<ArrowBackIcon />}
                >
                  Voltar
                </CustomButton>
                <CustomButton
                  colorType="primary"
                  disabled={isFormError || processandoOperacao}
                  isLoading={processandoOperacao}
                  startIcon={<CheckIcon />}
                  onClick={handleClickConfirmar}
                >
                  Confirmar
                </CustomButton>
              </div>
            </Grid>

          </Grid>
        )}
      </div>

      {/* Modal de Confirmação dos Dados */}
      <ModalConfirmacao
        aberto={abrirEspelho}
        onClose={() => setAbrirEspelho(false)}
        onConfirm={handleConfirmarOperacao}
        processando={processandoOperacao}
        titulo="CONFIRMAÇÃO"
        confirmarLabel="Confirmar"
        cancelarLabel="Cancelar"
        confirmarColor="secondary"
        maxWidth="md"
      >
        <Grid container spacing={2}>
          <Grid item md={6} xs={12}>
            <Typography variant="body2" color="textSecondary">NÚMERO DO LACRE</Typography>
            <Typography variant="body1"><b>{entregaVestigioForm.formState.values.lacre || 'NÃO INFORMADO'}</b></Typography>
          </Grid>
          <Grid item md={6} xs={12}>
            <Typography variant="body2" color="textSecondary">TIPO DA EMBALAGEM</Typography>
            <Typography variant="body1"><b>{entregaVestigioForm.formState.values.tipoEmbalagem || 'NÃO INFORMADO'}</b></Typography>
          </Grid>
        </Grid>

        <SecaoGenerica titulo="Dados da Entrega" spacing={2}>
          <Grid item md={6} xs={12}>
            <Typography variant="body2" color="textSecondary">SETOR DESTINO</Typography>
            <Typography variant="body1"><b>{entregaVestigioForm.formState.values.setorDestino ? entregaVestigioForm.formState.values.setorDestino.nome?.toUpperCase() : 'NÃO INFORMADO'}</b></Typography>
          </Grid>
          <Grid item md={6} xs={12}>
            <Typography variant="body2" color="textSecondary">RESPONSÁVEL PELO RECEBIMENTO</Typography>
            <Typography variant="body1">
              <b>
                {entregaVestigioForm.formState.values.usuarioRecebedor
                  ? entregaVestigioForm.formState.values.usuarioRecebedor.nome?.toUpperCase() === 'OUTRO'
                    ? entregaVestigioForm.formState.values.usuarioRecebedorInput?.toUpperCase() || 'NÃO INFORMADO'
                    : entregaVestigioForm.formState.values.usuarioRecebedor.nome?.toUpperCase()
                  : 'NÃO INFORMADO'}
              </b>
            </Typography>
          </Grid>
        </SecaoGenerica>


      </ModalConfirmacao>

    </Page >
  )
}
export default EntregarVestigio
